import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


// VUE-TOUR
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

// DISABLE USELESS WARNING IN CONSOLE
Vue.config.productionTip = false;

// POLYFILLS
import 'url-search-params-polyfill';

// FONT-AWESOME
import '@fortawesome/fontawesome-free/css/all.css'

// BUEFY
import Buefy from 'buefy'
import './assets/scss/libraries/buefy/loader.scss'
Vue.use(Buefy, {
    defaultIconPack: 'fa'
});

// IMPORT LODASH GLOBALLY
import _ from 'lodash';
Object.defineProperty(Vue.prototype, '$_', { value: _ });

// FILTERS
import DateFilter from "./common/filters/date";
Vue.filter("date", DateFilter);
import ErrorFilter from "./common/filters/error";
Vue.filter("error", ErrorFilter);

// LAYOUTS
import Blank from "./layout/BlankLayout.vue"
import WithTopNavigation from "./layout/WithTopNavigationLayout.vue"
import SheetLayout from "./layout/SheetLayout.vue"
import QualifyLayout from "./layout/QualifyLayout.vue"
Vue.component('layout-blank', Blank);
Vue.component('layout-with-top-navigation', WithTopNavigation);
Vue.component('layout-sheet', SheetLayout);
Vue.component('layout-qualify', QualifyLayout);

// PROXIMITY FEEDBACK
import ProximityAnimation from "@/components/Proximity/ProximityAnimation.vue"
Vue.component('proximity-animation', ProximityAnimation);

// TOOLTIP
import VTooltip from 'v-tooltip'
Vue.use(VTooltip);

// VUE I18N
import VueI18n from 'vue-i18n'
Vue.use(VueI18n);
//import { locales } from '@/common/localesList'
//let messages = {};
//locales.forEach(locale => messages[locale.code] = require(`@/common/locales/${locale.code}.json`))
export const i18n = new VueI18n({
    locale: store.state.settings.locale,
    fallbackLocale: 'en_US',
    //silentFallbackWarn: true,
    //messages
})

// BUS
const bus = new Vue();
Object.defineProperty(Vue.prototype, '$bus', {
    get() {
        return this.$root.bus
    }
});

// ASYNC COMPUTED
import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed)

// WA-MEDIABOX (LIGHTBOX)
import 'wa-mediabox';
const wamediabox = WAMediaBox;

// MIXINS
import mixins_global from './common/mixins/global'
import mixins_api from './common/mixins/api'
import './registerServiceWorker'
Vue.mixin(mixins_global);
Vue.mixin(mixins_api);

// MAIN VUE
new Vue({
    data: {
        bus,
        wamediabox
    },
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
